import React, { Component } from 'react';
import Loader from "../../../utils/Loader";
import { ToastContainer } from "react-toastify";
import Header from "../../../common_components/Header";
import { withRouter } from "../../../utils/withRouter";
import { connect } from "react-redux";
import { fill_action } from '../../../actions/fillCombo_action';
import { moduleActionId, sessionExpireMessage, toastError, toastSuccess, tokenInavlidMessage } from '../../../utils/constants';
import { get_roleDetails_action, insertUpdateRole_action } from '../../../actions/adminAction/role_action';

class RoleDetail extends Component {
    constructor(props) {
        super(props)
        this.state = {
            isLoading: false,
            RoleID: '', IsActive: '',
            RoleName: '',
            ModuleAccessList: [],
            moduleFillList: [],
            //validators
            RoleNameErr: '',
        }
    }
    componentDidMount() {
        window.scrollTo(0, 0)
        sessionStorage.setItem("currentPage", 'role')
        this.getFillList(moduleActionId, '', '', '', '').then(() => {
            if (sessionStorage.getItem('RoleIDSS') != 5) {
                this.setState({ RoleID: this.props?.location?.state?.RoleID })
                this.setState({ isViewFlag: true })
                this.getRoleDetail(this.props?.location?.state?.RoleID || null)


            }
            this.setState({ isLoading: false })
        })
    }
    getFillList(actionID, ModuleID, KeyValue, Value, UserID) {
        const { RoleID } = this.state
        this.setState({ isLoading: true });
        return new Promise((resolve) => {
            this.props
                .fill_action(actionID, ModuleID, KeyValue, Value, UserID)
                .then((data) => {
                    if (data.error !== 1) {
                        if (actionID === moduleActionId) {
                            this.setState({ moduleFillList: data.data });
                            resolve(true);
                        }
                    } else {
                        this.setState({ isLoading: false });
                        toastError(data.data.ErrorMsg);
                    }
                })
                .catch((err) => {
                    console.error(err);
                    this.setState({ isLoading: false });
                });
        });
    }
    getRoleDetail(RoleID) {
        this.setState({ isLoading: true });
        this.getFillList(moduleActionId, "", "", "", "").then(() => {
            if (RoleID) {
                // If RoleID exists, fetch role details
                this.props.get_roleDetails_action(RoleID)
                    .then((data) => {
                        if (data.error !== 1) {
                            const roleDetail = data.data[0][0];
                            const ModuleAccessList = data.data[1];

                            // Merge moduleFillList with fetched access details
                            const mergedModuleAccessList = this.state.moduleFillList.map(module => {
                                const moduleAccess = ModuleAccessList.find(access => access.ModuleID === module.ModuleID);
                                return moduleAccess
                                    ? { ...module, ...moduleAccess }
                                    : { ...module, FullAccess: false, ReadAccess: false, WriteAccess: false, UpdateAccess: false, DeleteAccess: false, Is_SpecialAccess: false, DownloadAccess: false, SendAccess: false };
                            });

                            this.setState({
                                RoleID: roleDetail.RoleID,
                                RoleName: roleDetail.RoleName,
                                IsActive: roleDetail.IsActive,
                                ModuleAccessList: mergedModuleAccessList
                            });
                        } else {
                            if (data.msg == sessionExpireMessage || data.msg == tokenInavlidMessage) {
                                //after session expire.....................
                                sessionStorage.clear();
                                this.props.navigate("/");
                                setTimeout(() => {
                                    toastError(data.msg);
                                }, 2000);
                            } else {
                                toastError(data.data);
                            }
                            toastError(data.data.ErrorMsg);
                        }
                        this.setState({ isLoading: false });
                    })
                    .catch((err) => {
                        console.error(err);
                        this.setState({ isLoading: false });
                    });
            } else {
                // If RoleID is not present, set default access as false
                console.log(this.state.moduleFillList, 'defaultModuleAccessList')
                const defaultModuleAccessList = this.state.moduleFillList.map(module => ({
                    ...module,
                    FullAccess: false,
                    ReadAccess: false,
                    WriteAccess: false,
                    UpdateAccess: false,
                    DeleteAccess: false,
                    Is_SpecialAccess: false,
                    DownloadAccess: false,
                    SendAccess: false
                }));
                this.setState({
                    RoleID: null,
                    RoleName: "",
                    IsActive: true,
                    ModuleAccessList: defaultModuleAccessList,
                    isLoading: false
                });
            }
        });
    }


    inputValidation() {
        const { RoleName, } = this.state
        var Err = false
        this.setState({
            RoleNameErr: '',
        })
        return new Promise((resolve) => {
            if (RoleName == '' || RoleName == null) {
                Err = true
                this.setState({ RoleNameErr: 'Please enter Role Name' })
            }
            resolve(Err)
        })
    }
    SubmitRole() {
        this.inputValidation().then(res => {
            if (!res) {
                const { RoleID, RoleName, ModuleAccessList } = this.state;

                const updatedModuleAccessList = ModuleAccessList.map(module => ({
                    ModuleID: module.ModuleID,
                    FullAccess: module.FullAccess,
                    ReadAccess: module.ReadAccess,
                    WriteAccess: module.WriteAccess,
                    UpdateAccess: module.UpdateAccess,
                    DeleteAccess: module.DeleteAccess,
                    Is_SpecialAccess: module.Is_SpecialAccess,
                    DownloadAccess: module.DownloadAccess,
                    SendAccess: module.SendAccess
                }));

                console.log(updatedModuleAccessList, 'ModuleAccessList');

                this.props.insertUpdateRole_action(RoleID, RoleName, updatedModuleAccessList)
                    .then((data) => {
                        if (data.error !== 1) {
                            toastSuccess('Role updated successfully');
                            this.setState({
                                RoleID: '', RoleName: '', ModuleAccessList: [],
                            }, () => this.props.navigate('/role_list'));
                        } else {
                            toastError(data.data.ErrorMsg);
                            if (data.msg == sessionExpireMessage || data.msg == tokenInavlidMessage) {
                                //after session expire.....................
                                sessionStorage.clear();
                                this.props.navigate("/");
                                setTimeout(() => {
                                    toastError(data.msg);
                                }, 2000);
                            } else {
                                toastError(data.data);
                            }
                        }
                    }).catch((e) => console.error(e));
            } else {
                toastError('Please Enter Mandatory Fields');
            }
        });
    }

    navigateBackRole() {
        this.props.navigate('/role_list');
    }
    handleAccessCheckbox = (e, ModuleID, accessType) => {
        console.log("Before Toggle:", this.state.ModuleAccessList); // Log the entire ModuleAccessList before the update

        this.setState(prevState => {
            const updatedModules = prevState.ModuleAccessList.map((module) => {
                if (module.ModuleID === ModuleID) {
                    console.log(`Toggling ${accessType} for ModuleID: ${ModuleID}`);

                    // Handle toggling FullAccess checkbox
                    if (accessType === 'FullAccess') {
                        const newFullAccess = !module.FullAccess;

                        // Set all access types to match FullAccess
                        const updatedModule = {
                            ...module,
                            FullAccess: newFullAccess,
                            ReadAccess: newFullAccess,
                            WriteAccess: newFullAccess,
                            UpdateAccess: newFullAccess,
                            DeleteAccess: newFullAccess,
                            Is_SpecialAccess: newFullAccess,
                            DownloadAccess: newFullAccess,
                            SendAccess: newFullAccess,
                        };
                        return updatedModule;
                    }

                    // Handle toggling individual access types
                    return {
                        ...module,
                        [accessType]: !module[accessType]
                    };
                }
                return module;
            });

            // Find the updated module to check if all individual access types are selected
            const updatedModule = updatedModules.find(module => module.ModuleID === ModuleID);
            const allAccessSelected = [
                'ReadAccess', 'WriteAccess', 'UpdateAccess', 'DeleteAccess',
                'Is_SpecialAccess', 'DownloadAccess', 'SendAccess'
            ].every(access => updatedModule[access]);

            console.log("All Access Selected: ", allAccessSelected);

            // Update FullAccess based on the individual access fields
            const updatedModulesWithFullAccess = updatedModules.map((module) => {
                if (module.ModuleID === ModuleID) {
                    return {
                        ...module,
                        FullAccess: allAccessSelected
                    };
                }
                return module;
            });

            console.log("After Toggle:", updatedModulesWithFullAccess); // Log the updated list after the change

            return { ModuleAccessList: updatedModulesWithFullAccess };
        });
    }


    render() {
        const { isLoading, RoleName, RoleNameErr, moduleFillList, ModuleAccessList } = this.state
        return (
            <>{isLoading ? (<Loader></Loader>) : (null)}
                <ToastContainer />
                <Header />
                <section className="registration_form">
                    <div class="container">
                        <h6 className='pt-2'>Role Details</h6>
                        <div class="row mt-15">
                            <div class="col-md-12">
                                <div class="row">
                                    <div class="col-md-12">
                                        <div class="custom_tabs" id="mytabs">
                                            <div class="tab-content">
                                                <div class="tab-pane active" id="Company_Profile_tab" role="tabpanel" aria-labelledby="Company_Profile_tab" tabindex="0">

                                                    <div class="row">
                                                        <div class="col-md-12">
                                                            <div class="row mb-3">
                                                                <div class="col-md-3">
                                                                    <div class="form-group">
                                                                        <label>Role Name<span className="red-star text-danger">*</span></label>
                                                                        <input type="text" class="form-control" placeholder="Enter Company name" value={RoleName} onChange={(e) => this.setState({ RoleName: e.target.value, RoleNameErr: '' })} maxLength={1000} />
                                                                        {<span className='text-danger text-start text-left d-block  ml-2'>{RoleNameErr}</span>}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <fieldset>
                                                        <legend className='mb-0 pb-0'>Module Access</legend>
                                                        <div class="row">
                                                            <div class="col-md-12">
                                                                <table className="table table-bordered mg-b-0">
                                                                    <thead>
                                                                        <tr>
                                                                            <th>Module Name</th>
                                                                            <th>Full Access</th>
                                                                            <th>Read Access</th>
                                                                            <th>Write Access</th>
                                                                            <th>Update Access</th>
                                                                            <th>Delete Access</th>
                                                                            <th>Special Access</th>
                                                                            <th>Download Access</th>
                                                                            <th>Send Access</th>
                                                                        </tr>
                                                                    </thead>
                                                                    <tbody id="myTable">
                                                                        {ModuleAccessList.length > 0 ? ModuleAccessList.map((data) => (
                                                                            <tr key={data.ModuleID}>
                                                                                <td>{data.ModuleName}</td>

                                                                                {/* FullAccess Checkbox */}
                                                                                <td>
                                                                                    <div className="form-group">
                                                                                        <div className="custom-control custom-checkbox" onClick={(e) => this.handleAccessCheckbox(e, data.ModuleID, 'FullAccess')}>
                                                                                            <input
                                                                                                type="checkbox"
                                                                                                className="custom-control-input"
                                                                                                checked={data.FullAccess}
                                                                                                value={data.FullAccess}
                                                                                            />
                                                                                            <label className="custom-control-label">&nbsp;</label>
                                                                                        </div>
                                                                                    </div>
                                                                                </td>


                                                                                {/* Other Access Checkboxes */}
                                                                                {['ReadAccess', 'WriteAccess', 'UpdateAccess', 'DeleteAccess', 'Is_SpecialAccess', 'DownloadAccess', 'SendAccess'].map(accessType => (
                                                                                    <td key={accessType}>
                                                                                        <div className="form-group">
                                                                                            <div className="custom-control custom-checkbox" onClick={(e) => this.handleAccessCheckbox(e, data.ModuleID, accessType)}>
                                                                                                <input
                                                                                                    type="checkbox"
                                                                                                    className="custom-control-input"
                                                                                                    checked={data[accessType]}
                                                                                                    value={data[accessType]}
                                                                                                />
                                                                                                <label className="custom-control-label">&nbsp;</label>
                                                                                            </div>
                                                                                        </div>
                                                                                    </td>
                                                                                ))}
                                                                            </tr>
                                                                        )) : (
                                                                            <tr>
                                                                                <td colSpan={12}>No Record Found</td>
                                                                            </tr>
                                                                        )}

                                                                    </tbody>
                                                                </table>
                                                            </div>
                                                        </div>
                                                    </fieldset>
                                                    <div class="row">
                                                        <div class="col-md-12 text-right">


                                                            <button class="btn btn-primary next_btn mx-2"
                                                                onClick={() => this.navigateBackRole()}
                                                            >
                                                                Back
                                                            </button>
                                                            <button class="btn btn-primary next_btn"
                                                                onClick={() => this.SubmitRole()}
                                                            >
                                                                Submit
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div >
                </section >
            </>
        )
    }
}
export default withRouter(connect(null, { fill_action, get_roleDetails_action, insertUpdateRole_action })(RoleDetail));